import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    const exchange = async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        if (res.data?.session_token) setToken(res.data.session_token);
        setUser(res.data);
        navigate("/", { replace: true, state: { user: res.data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Login failed";
        navigate("/login", { replace: true, state: { error: msg } });
      }
    };
    exchange();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3" data-testid="auth-callback-loading">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Signing you in…</p>
    </div>
  );
}
